module.exports = __webpack_public_path__ + "img/EOS.88610e5d.png";